import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { OverlappingOrderWarningPageText } from "./OverlappingOrderWarning-types";
import { AccountRoutesType } from "../../Shared/components/Navigation/navigationUtils";
import { ModalContent } from "../../Shared/components/Modal";
import { DialogActions, Stack } from "@mui/material";
import { Button } from "@mui/material";
import Typography from "@mui/material/Typography";
import { tokenReplace } from "../../Shared/utils/tokenReplacement";
/**
 * Shows a warning if an order has already been placed for the order period
 * Hard Reject - Redirects to the warning page. Customer cannot create an order
 * Soft Reject - A warning modal is shown but the customer can still create an order
 *
 * @param overlappingStatus
 * @param sku
 * @param navigate
 * @param showModal
 * @param closeModal
 */
export const showOverlappingOrderWarning = (overlappingStatus, navigate, showModal, closeModal, sku, tokenMap) => {
    var _a;
    const texttoDisplay = tokenReplace(OverlappingOrderWarningPageText.CHOOSE_MEALS, true, tokenMap);
    if (overlappingStatus.hardReject) {
        navigate("/OverlappingOrderWarning", {
            replace: true,
            state: { rejectMessage: overlappingStatus.rejectMessage, sku: sku },
        });
    }
    if (overlappingStatus.softReject) {
        showModal({
            title: (_a = overlappingStatus.rejectTitle) !== null && _a !== void 0 ? _a : OverlappingOrderWarningPageText.DEFAULT_TITLE,
            content: (_jsx(ModalContent, { children: _jsx(Typography, { children: overlappingStatus.rejectMessage }) })),
            actions: (_jsx(DialogActions, Object.assign({ sx: (theme) => ({
                    padding: theme.spacing(2, 3),
                }) }, { children: _jsxs(Stack, Object.assign({ sx: {
                        width: "100%",
                        flexDirection: { xx: "column", sm: "row" },
                        gap: 1,
                    } }, { children: [_jsx(Button, Object.assign({ size: "medium", variant: "outlined", color: "secondary", fullWidth: true, onClick: () => {
                                navigate(AccountRoutesType.ORDERS, { replace: true });
                                closeModal();
                            } }, { children: texttoDisplay })), _jsx(Button, Object.assign({ size: "medium", variant: "contained", color: "secondary", fullWidth: true, onClick: () => closeModal() }, { children: OverlappingOrderWarningPageText.CREATE_ORDER }))] })) }))),
        });
    }
};
